var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 3.33333C4.8956 3.33333 4.00016 4.22877 4.00016 5.33333C4.00016 6.4379 4.8956 7.33333 6.00016 7.33333C7.10476 7.33333 8.00016 6.4379 8.00016 5.33333C8.00016 4.22877 7.10476 3.33333 6.00016 3.33333ZM2.66683 5.33333C2.66683 3.49239 4.15922 2 6.00016 2C7.8411 2 9.3335 3.49239 9.3335 5.33333C9.3335 7.17427 7.8411 8.66667 6.00016 8.66667C4.15922 8.66667 2.66683 7.17427 2.66683 5.33333ZM14.4716 6.19526C14.7319 6.45561 14.7319 6.87773 14.4716 7.13807L11.8049 9.80473C11.5446 10.0651 11.1224 10.0651 10.8621 9.80473L9.52876 8.4714C9.26843 8.21107 9.26843 7.78893 9.52876 7.5286C9.7891 7.26827 10.2112 7.26827 10.4716 7.5286L11.3335 8.39053L13.5288 6.19526C13.7891 5.93491 14.2112 5.93491 14.4716 6.19526ZM2.80194 10.2263C3.64964 9.6612 4.78234 9.33333 6.00016 9.33333C7.21796 9.33333 8.3507 9.6612 9.19836 10.2263C10.0414 10.7884 10.6668 11.638 10.6668 12.6667C10.6668 13.0349 10.3684 13.3333 10.0002 13.3333C9.63196 13.3333 9.3335 13.0349 9.3335 12.6667C9.3335 12.2225 9.06343 11.7389 8.45876 11.3357C7.85876 10.9357 6.9915 10.6667 6.00016 10.6667C5.00885 10.6667 4.14154 10.9357 3.54154 11.3357C2.93687 11.7389 2.66683 12.2225 2.66683 12.6667C2.66683 13.0349 2.36835 13.3333 2.00016 13.3333C1.63198 13.3333 1.3335 13.0349 1.3335 12.6667C1.3335 11.638 1.95889 10.7884 2.80194 10.2263Z",
    fill: "#15C7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignLead);
export default __webpack_public_path__ + "static/media/assignLead.55912d3da2b847853780181716b13cb1.svg";
export { ForwardRef as ReactComponent };